// extracted by mini-css-extract-plugin
export default {"Icon":"w6YZi4A7","IconContainer":"msa8FEyv","ButtonPlaceholder":"ZsoPmDW2","ButtonSkeleton":"_dwKD_CD","IconPlaceholder":"hV4s8jn6","Instructions":"AUylziPZ"};